import { LoaderCircle } from 'lucide-react';
import styles from './LoadingSpinner.module.scss';

type LoadingSpinnerProps = {
    size?: number;
    borderWidth?: number;
    color?: string;
    className?: string;
    text?: string;
};

const LoadingSpinner = ({
    size = 60,
    borderWidth = 6,
    color = '#9b51e0',
    className = '',
    text = 'Loading...',
}: LoadingSpinnerProps) => {
    // Default values
    const spinnerSize = size;
    const spinnerBorderWidth = borderWidth;
    const spinnerColor = color;

    // Create rgba version with 0.2 opacity for the non-active border
    const rgbaColor = spinnerColor.startsWith('#')
        ? `rgba(${parseInt(spinnerColor.slice(1, 3), 16)}, ${parseInt(spinnerColor.slice(3, 5), 16)}, ${parseInt(spinnerColor.slice(5, 7), 16)}, 0.2)`
        : 'rgba(155, 81, 224, 0.2)'; // Default if not a hex color

    const spinnerStyle = {
        width: `${spinnerSize}px`,
        height: `${spinnerSize}px`,
        border: `${spinnerBorderWidth}px solid ${rgbaColor}`,
        borderTopColor: spinnerColor,
    };

    return (
        <div className={`${styles.loadingSpinnerContainer} ${className || ''}`}>
            <LoaderCircle size={26} className={styles.spinner} color={spinnerColor} /> {text}
        </div>
    );
};

export default LoadingSpinner;
